<div mat-dialog-title class="title-container">
  <div class="form-container">
    <div class="section-header"><span>User</span></div>
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="lc-tab-group">
      <mat-tab>
        <ng-template mat-tab-label>
          <mat-icon class="icon-32 lc-label-icon" svgIcon="details"></mat-icon>
          <span class="tab-label">Details</span>
        </ng-template>
        <div class="main-tab-content-wrapper">
          <form [formGroup]="form">
            <div class="full-row-container">
              <div class="form-field">
                <mat-form-field class="lc-form-field" appearance="outline">
                  <label>Name</label>
                  <input matInput formControlName="name" />
                </mat-form-field>
              </div>

              <div class="form-field">
                <mat-form-field class="lc-form-field" appearance="outline">
                  <label>Role</label>
                  <mat-select (selectionChange)="setRightGroups($event)" formControlName="role">
                    <mat-option *ngFor="let role of displayingRoles$ | async" [value]="role.id">
                      {{ role.name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="form-field full-width">
              <mat-form-field appearance="outline" class="full-width lc-form-field">
                <label>E-mail</label>
                <input #emailInput (keyup)="verifyEmail(emailInput.value)" (input)="verifyEmail(emailInput.value)"
                  matInput placeholder="pat@example.com" formControlName="eMailAddress" />
                <mat-error *ngIf="isFormControlInvalid('eMailAddress')">{{ getErrorMessage("eMailAddress") }}
                </mat-error>
              </mat-form-field>
            </div>

            <div *ngIf="isAdminPanelMode" class="form-field full-width lc-form-field">
              <mat-form-field appearance="outline" class="full-width">
                <label>Laboratories</label>
                <mat-select formControlName="laboratories" #laboratoriesSelect multiple
                  (openedChange)="laboratoriesSelectToggled()">
                  <mat-select-trigger>
                    {{
                    laboratoriesSelect.value
                    ? getLaboratoryName(laboratoriesSelect.value[0])
                    : ""
                    }}
                    <span *ngIf="laboratoriesSelect.value?.length > 1">
                      (+{{ laboratoriesSelect.value.length - 1 }}
                      {{
                      laboratoriesSelect.value?.length === 2
                      ? "other"
                      : "others"
                      }})
                    </span>
                  </mat-select-trigger>
                  <mat-form-field class="form-field inner-mat-input lc-form-field" appearance="outline">
                    <input matInput #laboratorySearch placeholder="Search..."
                      (input)="filterLaboratories(laboratorySearch.value)" />
                  </mat-form-field>
                  <div class="overflow-list">
                    <div *ngFor="let laboratory of laboratories$ | async">
                      <div [hidden]="!isLaboratoryInFilter(laboratory)">
                        <mat-option [value]="laboratory.id">{{
                          laboratory.name
                          }}</mat-option>
                      </div>
                    </div>
                  </div>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="full-row-container">
              <div *ngIf="!isAdminPanelMode" class="form-field">
                <mat-form-field class="lc-form-field" appearance="outline">
                  <label>Login name</label>
                  <input #loginNameInput matInput formControlName="loginName" type="text"
                    (keyup)="verifyLoginName(loginNameInput.value)" (input)="verifyLoginName(loginNameInput.value)" />
                </mat-form-field>
              </div>

              <div *ngIf="!isAdminPanelMode" class="form-field">
                <mat-form-field class="lc-form-field" appearance="outline">
                  <label>Password</label>
                  <input matInput (focus)="clearPassword()" (focusout)="passwordLostFocus()" formControlName="password"
                    [type]="'password'" />
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </mat-tab>
      <mat-tab *ngIf="userIsSaved">
        <ng-template mat-tab-label>
          <mat-icon class=" lc-label-icon" color="primary">email</mat-icon>
          <span class="tab-label">E-mail</span>
        </ng-template>
        <div class="main-tab-content-wrapper">
          <div class="table-wrapper">
            <div class="first">
              <div class="section-header">
                <span></span>
                <button *ngIf="hasAdminMaintainUsers || (hasMaintainCustomerUsers && hasMaintainCustomer)"
                  class="add-button lc-stroked-button" mat-stroked-button (click)="addNewEmailTemplate()">
                  <mat-icon svgIcon="add-circle"></mat-icon>Add
                </button>
              </div>
            </div>
            <div class="second templates-table grid-scrollable-container">
              <table class="lc-table" mat-table #templatesSort="matSort" [dataSource]="templatesDataSource" matSort>
                <!-- Name Column -->
                <ng-container matColumnDef="laboratoryEmailTemplateName">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Name
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.laboratoryEmailTemplateName }}
                  </td>
                </ng-container>
                <!-- Edit Column -->
                <ng-container matColumnDef="edit">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <app-edit-view-button (buttonClicked)="editEmailTemplate(element)" [shouldShowButton]="true"
                      [isEdit]="hasAdminMaintainUsers || (hasMaintainCustomerUsers && hasMaintainCustomer)"
                      [isView]="!hasMaintainCustomerUsers || !(hasMaintainCustomerUsers && hasMaintainCustomer)">
                    </app-edit-view-button>
                  </td>
                </ng-container>
                <!-- Delete Column -->
                <ng-container matColumnDef="delete"
                  *ngIf="hasAdminMaintainUsers || (hasMaintainCustomerUsers && hasMaintainCustomer)">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-button color="primary" (click)="deleteEmailTemplate(element.id)">
                      <mat-icon svgIcon="delete"></mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedTemplatesColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedTemplatesColumns"
                  [ngClass]="{ selectedRow: selectedEmailId === row.id }" (click)="selectEmailRow(row.id)"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="5" *ngIf="templatesDataSource.data">
                    No data to display
                  </td>
                </tr>
              </table>
            </div>
            <div class="third">
              <mat-paginator #templatesPaginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15]"></mat-paginator>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div mat-dialog-content>
  <div *ngIf="!isAdminPanelMode && emailExists" id="warning-container">
    <h3> {{ getEmailErrorMessage() }} </h3>
  </div>
  <div *ngIf="isAdminPanelMode && emailExists" id="warning-container">
    <h3>User with provided email already exists.</h3>
  </div>
</div>
<div mat-dialog-content>
  <div *ngIf="!isAdminPanelMode && loginNameExists" id="warning-container">
    <h3>
      User login name already exists. The login name must be unique.
    </h3>
  </div>
</div>
<div id="footer-buttons-container">
  <button class="lc-stroked-button lc-primary" [disabled]="!canSave()" mat-stroked-button (click)="save()"
    *ngIf="hasAdminMaintainUsers || (hasMaintainCustomerUsers && hasMaintainCustomer)">
    <mat-icon svgIcon="tick"></mat-icon>Save
  </button>
  <button class="lc-stroked-button lc-primary" mat-stroked-button (click)="cancel()">
    <mat-icon svgIcon="close"></mat-icon> {{ labelForClose }}
  </button>
</div>